import React from "react";

import PlayCircleFilledIcon from "@material-ui/icons/PlayCircleFilled";
import FavoriteBorderIcon from "@material-ui/icons/FavoriteBorder";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";

import { useDataLayer } from "./DataLayer";

import Header from "./Header";
import SongRow from "./SongRow";

import "./Body.css";

function Body({ spotify }) {
  const [{ default_playlist }] = useDataLayer();

  const { owner, name, followers, description, images, tracks } =
    default_playlist;

  return (
    <div className="body">
      <Header spotify={spotify} />

      <div className="body__info">
        <img
          src={images && images[0]?.url}
          alt={name}
          className="body__discoverImage"
        />
        <div className="body__infoText">
          <strong>PLAYLIST</strong>
          <h2>{name}</h2>
          <p>{description}</p>
          <div className="playlistStats">
            {"by "}
            <span className="playlistStats__owner">
              <strong>{owner?.display_name}</strong>{" "}
            </span>
            {" - "}
            <span className="playlistStats__likes">
              {followers?.total} likes
            </span>
            {" - "}
            <span className="playlistStats__trackCount">
              {tracks?.items?.length} songs
            </span>
          </div>
        </div>
      </div>

      {/* Big play button & Song list */}
      <div className="body__songs">
        <div className="body__icons">
          <div className="body__playIconContainer">
            <div className="body__playIcon--bg"></div>
            <PlayCircleFilledIcon fontSize="large" className="body__playIcon" />
          </div>
          <FavoriteBorderIcon className="body__likeIcon" />
          <MoreHorizIcon className="body__moreIcon" />
        </div>

        {tracks?.items &&
          tracks?.items.map((item, idx) => (
            <SongRow item={item} index={idx} key={item?.track?.id} />
          ))}
      </div>
    </div>
  );
}

export default Body;
